// src/components/ShareLinkModal.jsx
import React, { useState, useEffect } from "react";
import {
  X,
  Copy,
  MessageCircle,
  Check,
  AlertCircle,
  Mail,
  MessageSquare,
  Link as LinkIcon,
} from "lucide-react";

const ShareLinkModal = ({
  isOpen,
  onClose,
  title = "リンク共有",
  subtitle = "",
  link,
  itemLabel,
  quantity = 1,
  dateTime = "",
  location = "",
  address = "",
  mapUrl = "",
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!isOpen) setCopied(false);
  }, [isOpen]);

  if (!isOpen) return null;

const buildMessage = () => {
  const lines = [`【ご招待】${itemLabel}`];

  if (dateTime) {
    lines.push("", `日時：${dateTime}`);
  }

  if (location) {
    lines.push(`場所：${location}`);
  }

  if (address) {
    lines.push(`住所：${address}`);
  }

  if (mapUrl) {
    lines.push(`地図：${mapUrl}`);
  }

  lines.push(
    "",
    "こちらのリンクから招待券を発行のうえ、ご入場ください。",
    "",
    link,
    "",
    "携帯番号を認証すると、すぐにご利用いただけます。"
  );

  return lines.join("\n");
};

  const sendLine = () => {
    const message = buildMessage();
    window.open(
      `https://line.me/R/msg/text/?${encodeURIComponent(message)}`,
      "_blank"
    );
    onClose?.();
  };

  const sendSms = () => {
    const message = buildMessage();
    window.open(`sms:&body=${encodeURIComponent(message)}`, "_blank");
  };

  const sendMail = () => {
    const subject = `【ご招待】${itemLabel}のご案内`;
    const body = buildMessage();
    window.open(
      `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`,
      "_blank"
    );
  };

  const copyLink = async () => {
    await navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
      onClose?.();
    }, 800);
  };

  const disableAll = !link;

  return (
    <div className="fixed inset-0 bg-black/50 z-[14000] flex items-center justify-center p-4 backdrop-blur-sm">
      <div className="bg-white w-full max-w-sm rounded-3xl p-5 shadow-2xl border border-gray-100 relative font-sans">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-10 h-10 rounded-3xl bg-white border border-gray-100 flex items-center justify-center text-gray-500"
        >
          <X size={18} />
        </button>

        <div className="text-base font-black text-gray-900">{title}</div>
        {subtitle && (
          <div className="text-xs text-gray-500 font-bold mt-1">{subtitle}</div>
        )}

        <div className="mt-4 p-4 rounded-3xl border border-gray-200 bg-gray-50">
          <div className="text-sm font-black text-gray-900">{itemLabel}</div>
          <div className="text-xs text-gray-500 mt-1">1 link = 1 person</div>

          {(dateTime || location || address) && (
            <div className="mt-3 space-y-1 text-[11px] text-gray-600 font-bold leading-relaxed">
              {dateTime && <div>日時：{dateTime}</div>}
              {location && <div>場所：{location}</div>}
              {address && <div>住所：{address}</div>}
            </div>
          )}

          <div className="mt-3 flex items-start gap-2 text-xs text-amber-800 bg-amber-50 border border-amber-200 p-3 rounded-3xl">
            <AlertCircle size={16} />
            1人につき1リンクを個別に送ってください。
          </div>
        </div>

        <div className="mt-4 space-y-3">
          <button
            onClick={sendLine}
            disabled={disableAll}
            className="w-full py-3 rounded-3xl bg-gray-900 text-white font-black flex items-center justify-center gap-2"
          >
            <MessageCircle size={18} />
            LINEで送る
          </button>

          <div className="grid grid-cols-2 gap-2">
            <button
              onClick={sendSms}
              disabled={disableAll}
              className="py-2.5 rounded-xl bg-white border border-gray-200 font-black text-sm flex items-center justify-center gap-2"
            >
              <MessageSquare size={16} />
              SMS
            </button>

            <button
              onClick={sendMail}
              disabled={disableAll}
              className="py-2.5 rounded-xl bg-white border border-gray-200 font-black text-sm flex items-center justify-center gap-2"
            >
              <Mail size={16} />
              メール
            </button>
          </div>

          <div className="pt-3 border-t border-gray-100">
            <div className="flex items-center gap-2 text-[10px] text-gray-500 font-black uppercase">
              <LinkIcon size={12} /> link
            </div>

            <div className="mt-2 flex items-center gap-2 bg-gray-50 p-2 rounded-3xl border border-gray-200">
              <div className="flex-1 truncate text-[11px] font-mono text-gray-700">
                {link}
              </div>

              <button
                onClick={copyLink}
                disabled={disableAll}
                className={`w-10 h-10 rounded-xl border flex items-center justify-center ${
                  copied
                    ? "bg-gray-900 text-white"
                    : "bg-white text-gray-600 border-gray-200"
                }`}
              >
                {copied ? <Check size={18} /> : <Copy size={16} />}
              </button>
            </div>

            <button
              onClick={onClose}
              className="w-full mt-3 py-3 rounded-3xl bg-white border border-gray-200 text-gray-700 font-black"
            >
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareLinkModal;
/*
// src/components/ShareLinkModal.jsx
import React, { useState, useEffect } from "react";
import {
  X,
  Copy,
  MessageCircle,
  Check,
  AlertCircle,
  Mail,
  MessageSquare,
  Link as LinkIcon,
} from "lucide-react";

const ShareLinkModal = ({
  isOpen,
  onClose,
  title = "リンク共有",
  subtitle = "",
  link,
  itemLabel,
  quantity = 1,
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!isOpen) setCopied(false);
  }, [isOpen]);

  if (!isOpen) return null;
/*
  const buildMessage = () => {
    return (
      `🔗 ${itemLabel}\n\n` +
      `こちらのリンクからご利用いただけます。\n\n` +
      `※このリンクは1人につき1つ使用できます。\n` +
      `${link}`
    );
  };
*//*
const buildMessage = () => {
  return [
    `${itemLabel}`,
    "",
    "こちらのリンクからご利用いただけます。",
    "",
    link, // URLは単独行
    "",
    "※このリンクは1人につき1つ使用できます。",
  ].join("\n");
};

  const sendLine = () => {
    const message = buildMessage();
    window.open(`https://line.me/R/msg/text/?${encodeURIComponent(message)}`, "_blank");
    onClose?.();
  };

  const sendSms = () => {
    const message = buildMessage();
    window.open(`sms:&body=${encodeURIComponent(message)}`, "_blank");
  };

  const sendMail = () => {
    const subject = `${itemLabel}のご案内`;
    const body = buildMessage();
    window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`, "_blank");
  };

  const copyLink = async () => {
    await navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
      onClose?.();
    }, 800);
  };

  const disableAll = !link;

  return (
    <div className="fixed inset-0 bg-black/50 z-[14000] flex items-center justify-center p-4 backdrop-blur-sm">
      <div className="bg-white w-full max-w-sm rounded-3xl p-5 shadow-2xl border border-gray-100 relative font-sans">

        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-10 h-10 rounded-3xl bg-white border border-gray-100 flex items-center justify-center text-gray-500"
        >
          <X size={18} />
        </button>

        <div className="text-base font-black text-gray-900">{title}</div>
        {subtitle && (
          <div className="text-xs text-gray-500 font-bold mt-1">{subtitle}</div>
        )}

        <div className="mt-4 p-4 rounded-3xl border border-gray-200 bg-gray-50">
          <div className="text-sm font-black text-gray-900">{itemLabel}</div>
          <div className="text-xs text-gray-500 mt-1">1 link = 1 person</div>

          <div className="mt-3 flex items-start gap-2 text-xs text-amber-800 bg-amber-50 border border-amber-200 p-3 rounded-3xl">
            <AlertCircle size={16} />
            1人につき1リンクを個別に送ってください。
          </div>
        </div>

        <div className="mt-4 space-y-3">

          <button
            onClick={sendLine}
            disabled={disableAll}
            className="w-full py-3 rounded-3xl bg-gray-900 text-white font-black flex items-center justify-center gap-2"
          >
            <MessageCircle size={18} />
            LINEで送る
          </button>

          <div className="grid grid-cols-2 gap-2">
            <button
              onClick={sendSms}
              disabled={disableAll}
              className="py-2.5 rounded-xl bg-white border border-gray-200 font-black text-sm flex items-center justify-center gap-2"
            >
              <MessageSquare size={16} />
              SMS
            </button>

            <button
              onClick={sendMail}
              disabled={disableAll}
              className="py-2.5 rounded-xl bg-white border border-gray-200 font-black text-sm flex items-center justify-center gap-2"
            >
              <Mail size={16} />
              メール
            </button>
          </div>

          <div className="pt-3 border-t border-gray-100">
            <div className="flex items-center gap-2 text-[10px] text-gray-500 font-black uppercase">
              <LinkIcon size={12} /> link
            </div>

            <div className="mt-2 flex items-center gap-2 bg-gray-50 p-2 rounded-3xl border border-gray-200">
              <div className="flex-1 truncate text-[11px] font-mono text-gray-700">
                {link}
              </div>

              <button
                onClick={copyLink}
                disabled={disableAll}
                className={`w-10 h-10 rounded-xl border flex items-center justify-center ${
                  copied
                    ? "bg-gray-900 text-white"
                    : "bg-white text-gray-600 border-gray-200"
                }`}
              >
                {copied ? <Check size={18} /> : <Copy size={16} />}
              </button>
            </div>

            <button
              onClick={onClose}
              className="w-full mt-3 py-3 rounded-3xl bg-white border border-gray-200 text-gray-700 font-black"
            >
              閉じる
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ShareLinkModal;
*/